import {
  CLIENTS_GET_REQUEST,
  CLIENTS_GET_REQUEST_FAILED,
  CLIENTS_GET_REQUEST_SUCCESS,
  CLIENTS_CLEAR_DATA,
  CLIENT_ADD_REQUEST,
  CLIENT_ADD_REQUEST_FAILED,
  CLIENT_ADD_REQUEST_SUCCESS,
  CLIENT_EDIT_REQUEST,
  CLIENT_EDIT_REQUEST_FAILED,
  CLIENT_EDIT_REQUEST_SUCCESS,
  CLIENT_REMOVE_REQUEST,
  CLIENT_REMOVE_REQUEST_FAILED,
  CLIENT_REMOVE_REQUEST_SUCCESS,
  CLIENT_UPGRADE_REQUEST,
  CLIENT_UPGRADE_REQUEST_SUCCESS,
  CLIENT_UPGRADE_REQUEST_FAILED,
  VERTICALS_GET_REQUEST,
  VERTICALS_GET_REQUEST_FAILED,
  VERTICALS_GET_REQUEST_SUCCESS,
  CLIENT_SEARCH_REQUEST,
  CLIENT_SEARCH_REQUEST_FAILED,
  CLIENT_SEARCH_REQUEST_SUCCESS
} from "../../constants";

export const clearClientsData = () => {
  return { type: CLIENTS_CLEAR_DATA };
};
export const getClientsRequest = () => {
  return { type: CLIENTS_GET_REQUEST };
};
export const addClientRequest = payload => {
  return { type: CLIENT_ADD_REQUEST, payload };
};
export const editClientRequest = payload => {
  return { type: CLIENT_EDIT_REQUEST, payload };
};
export const removeClientRequest = payload => {
  return { type: CLIENT_REMOVE_REQUEST, payload };
};
export const upgradeClientRequest = () => {
  return { type: CLIENT_UPGRADE_REQUEST };
};
export const searchClientRequest = payload => {
  return { type: CLIENT_SEARCH_REQUEST, payload };
};
export const getVerticalsRequest = () => {
  return { type: VERTICALS_GET_REQUEST };
};

export const getClientsRequestFailed = payload => {
  return { type: CLIENTS_GET_REQUEST_FAILED, payload };
};
export const addClientRequestFailed = payload => {
  return { type: CLIENT_ADD_REQUEST_FAILED, payload };
};
export const editClientRequestFailed = payload => {
  return { type: CLIENT_EDIT_REQUEST_FAILED, payload };
};
export const removeClientRequestFailed = payload => {
  return { type: CLIENT_REMOVE_REQUEST_FAILED, payload };
};
export const upgradeClientRequestFailed = payload => {
  return { type: CLIENT_UPGRADE_REQUEST_FAILED, payload };
};
export const searchClientRequestFailed = payload => {
  return { type: CLIENT_SEARCH_REQUEST_FAILED, payload };
};
export const getVerticalsRequestFailed = payload => {
  return { type: VERTICALS_GET_REQUEST_FAILED, payload };
};

export const getClientsRequestSuccess = payload => {
  return { type: CLIENTS_GET_REQUEST_SUCCESS, payload };
};
export const addClientRequestSuccess = payload => {
  return { type: CLIENT_ADD_REQUEST_SUCCESS, payload };
};
export const editClientRequestSuccess = payload => {
  return { type: CLIENT_EDIT_REQUEST_SUCCESS, payload };
};
export const removeClientRequestSuccess = payload => {
  return { type: CLIENT_REMOVE_REQUEST_SUCCESS, payload };
};
export const upgradeClientRequestSuccess = payload => {
  return { type: CLIENT_UPGRADE_REQUEST_SUCCESS, payload };
};
export const searchClientRequestSuccess = payload => {
  return { type: CLIENT_SEARCH_REQUEST_SUCCESS, payload };
};
export const getVerticalsRequestSuccess = payload => {
  return { type: VERTICALS_GET_REQUEST_SUCCESS, payload };
};
